import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH(meetingId) {
      var queryParams = {
        "exists[parent_resolution]": false,
        "order[position]": "ASC",
      };
      return this.get(links.MEETING_RESOLUTION_FETCH(meetingId), {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET_LAST_POSITION(meetingId) {
      return this.get(links.MEETING_RESOLUTION_GET_LAST_POSITION(meetingId));
    },
    // NOTE: get the ones that belong to certain meeting (relatedId = meeting_id)
    //       + custom filter: "*meeting-resolutions-voting-category*"
    //         custom sort by: "*meeting-resolutions-voting-category*"
    //       + custom filter: "*meeting-resolutions-majority*"
    //         custom sort by: "*meeting-resolutions-majority*"
    QUERY_FETCH(agencyId, queryParams, relatedId) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      processedQueryParams["exists[parent_resolution]"] = false;
      // filters
      queryParams.filter.forEach(filter => {
        if (filter.column == "*meeting-resolutions-voting-category*") {
          processedQueryParams["voting_category"] = filter.value;
        } else if (filter.column == "*meeting-resolutions-majority*") {
          // HACK: ..
          if (filter.value !== "hackNull") processedQueryParams["majority"] = filter.value;
          else processedQueryParams["exists[majority]"] = false;
        } else {
          processedQueryParams[filter.column] = filter.value;
        }
      });
      // order
      if (queryParams.sort.by == "*meeting-resolutions-voting-category*") {
        processedQueryParams[`order[voting_category.name]`] = queryParams.sort.dir.toLowerCase();
      } else if (queryParams.sort.by == "*meeting-resolutions-majority*") {
        processedQueryParams[`order[majority.name]`] = queryParams.sort.dir.toLowerCase();
      } else {
        processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      }
      // page
      processedQueryParams.page = queryParams.page;
      return this.get(links.MEETING_RESOLUTION_QUERY_FETCH(relatedId), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.MEETING_RESOLUTION_GET(id));
    },
    PUT(item) {
      if (item.position) {
        item.position = parseInt(item.position);
      }
      return this.put(links.MEETING_RESOLUTION_PUT(item.id), item, {
        dataTransformer: ({ data }) => {
          delete data.resolution_votes;
          return data;
        },
      });
    },
    DELETE(item) {
      return this.delete(links.MEETING_RESOLUTION_DELETE(item.id), {
        delete: item.id,
      });
    },
    // ... use just this instead of the other 3
    POST(item) {
      return this.post(links.MEETING_RESOLUTION_POST(), item);
    },
    POST_FROM_RESOLUTIONS(item) {
      return this.post(links.MEETING_RESOLUTION_POST_FROM_RESOLUTIONS(), item);
    },
    POST_FROM_CATALOGS(item) {
      return this.post(links.MEETING_RESOLUTION_POST_FROM_CATALOGS(), item);
    },
    DUPLICATE_MEDIA(meetingResolution, files) {
      return this.post(
        links.MEETING_RESOLUTION_DUPLICATE_MEDIA(),
        {
          meeting_resolution_id: meetingResolution.id,
          files: files,
        },
        {
          save: false,
        }
      );
    },
    SAVE_POSITION(item) {
      return this.post(links.MEETING_RESOLUTION_SAVE_POSITION(), item);
    },
    UPDATE_RESOLUTIONS_NUMBERS(meetingId) {
      return this.post(
        links.MEETING_RESOLUTION_UPDATE_RESOLUTIONS_NUMBERS(),
        {
          meeting_id: meetingId,
        },
        {
          save: false,
        }
      );
    },
    UPDATE_MEETING_RESOLUTION_WITH_MEDIA(item) {
      return this.put(links.UPDATE_MEETING_RESOLUTION_WITH_MEDIA(item.id), item, {
        dataTransformer: ({ data }) => {
          delete data.resolution_votes;
          return data;
        },
      });
    },
    CREATE_MEETING_RESOLUTION_WITH_MEDIA(item) {
      return this.post(links.CREATE_MEETING_RESOLUTION_WITH_MEDIA(), item, {
        dataTransformer: ({ data }) => {
          delete data.resolution_votes;
          return data;
        },
      });
    },
    CREATE_DURING_MEETING(meetingResolution) {
      return this.post(links.MEETING_RESOLUTION_CREATE_DURING_MEETING(), meetingResolution);
    },
    DELETE_DURING_MEETING(meetingResolution) {
      return this.delete(links.MEETING_RESOLUTION_DELETE_DURING_MEETING(meetingResolution.id), {
        delete: meetingResolution.id,
      });
    },
    RESET(meetingResolution) {
      return this.put(links.MEETING_RESOLUTION_RESET(meetingResolution.id), meetingResolution);
    },
  },
};
